import { render, staticRenderFns } from "./ProjectRiskCreateDialog.vue?vue&type=template&id=fc09a6f8&scoped=true"
import script from "./ProjectRiskCreateDialog.vue?vue&type=script&lang=js"
export * from "./ProjectRiskCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjectRiskCreateDialog.vue?vue&type=style&index=0&id=fc09a6f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc09a6f8",
  null
  
)

export default component.exports